// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/role/role.less
// module id = 2249
// module chunks = 0